<template>
  <div class="app-container">

    <!-- 工具栏 -->
    <div class="filter-container">
      <el-button size="small" class="filter-item" type="danger" disabled>批量删除</el-button>
      <div class="" style="float:right;margin-right:1%;margin-top:10px;">
        <el-popover width="500" trigger="click">
          <el-button slot="reference" size="mini" icon="el-icon-s-grid" style="font-size: 16px;padding:5px 10px;" title="筛选列"><i class="el-icon-caret-bottom"></i></el-button>
          <template>
            <div v-for="(listdis, index) in columnNamearr" :key="index">
              <div class="shaixuanlielist" @click='tablelistdis(listdis)' :class="listdis.show?'shaixuantextcolor':''">
                <el-checkbox v-model="listdis.show" style="margin-right:5px;"></el-checkbox>{{listdis.label}}
              </div>
            </div>
          </template>
        </el-popover>
      </div>
    </div>

    <!-- table 列表 -->
    <el-table :header-cell-style="{background:'#eef1f6',color:'#606266',fontSize:'12px'}" border fit v-loading="listLoading" ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
      max-height="500px" @selection-change="handleSelectionChange">
<!-- :selectable="selectable" -->
      <el-table-column type="selection" fixed width="55" ></el-table-column>

      <el-table-column v-for="(item, index) in columnNamearr" :key="index" :label="item.label" :fixed="item.label == 'id' ? true : false" :min-width="item.label == 'id' ? '90px' : '150px'" style="width: 100%"
        v-if="item.show">
        <template slot-scope="scope">
          <span v-if="indexOfstr(scope.row[item.label])">
            <span v-if="scope.row[item.label] && scope.row[item.label].length > 15">
              <el-tooltip placement="top">
                <div slot="content">{{scope.row[item.label]}}</div>
                <div><span class="link" @click="openPopup(scope.row,scope.row[item.label])"> {{ scope.row[item.label] | quzifu | neirongsuojian }} </span></div>
              </el-tooltip>
            </span>
            <span v-else class="link" @click="openPopup(scope.row,scope.row[item.label])">{{scope.row[item.label] | quzifu}}</span>
          </span>
          <span v-else>
            <span v-if="scope.row[item.label] && scope.row[item.label].length > 15">
              <el-tooltip placement="top">
                <div slot="content">{{scope.row[item.label]}}</div>
                <div>{{ scope.row[item.label] | neirongsuojian }}</div>
              </el-tooltip>
            </span>
            <span v-else>{{scope.row[item.label]}}</span>
          </span>

        </template>
      </el-table-column>

      <!-- 操作 -->
      <el-table-column label="操作" prop="caozuo" width="160px" class-name="small-padding fixed-width" fixed="right">
        <template slot-scope="scope">
          <!-- :disabled="!scope.row.caozuo[0]" -->
          <el-button size="mini" style="padding: 4px 15px;" type="primary" disabled>编辑</el-button>
          <el-button size="mini" style="padding: 4px 15px;" type="danger" disabled>删除</el-button>
        </template>
      </el-table-column>

    </el-table>

    <!-- 分页 -->
    <pagination v-show="total>0" :total="total" :page.sync="listQuery.pageNo" :limit.sync="listQuery.pageSize" @pagination="getList" />

    <!-- 说明详细信息 并且可以复制 -->
    <copy-dialog ref="copyDialog"></copy-dialog>

    <!-- 表名弹窗 -->
    <data-table ref="infotable" :infotableName="infotableName" :datainfo="datainfo"></data-table>

  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { ajax_middleTableData } from '@Sys~/api/sys'
import CopyDialog from '../copyDialog'
import DataTable from './DataTable'
export default {
  props: {
    tableName: {
      type: String,
      default: ''
    }
  },
  filters: {
    neirongsuojian(value) {
      console.log('=========',value)
      if (value) {
        if (value.length > 15) {
          return value.substring(0, 15) + "...";
        } else {
          return value
        }
      } else {
        return ""
      }
    },
    quzifu(value) {
      return value.replace("_click_", "");
    },
  },
  components: { Pagination, CopyDialog, DataTable },
  data() {
    return {
      listLoading: false,
      tableData: [],
      columnNamearr: [],
      multipleSelection: [], // 已选数据
      total: 0,
      listQuery: {
        pageNo: 1,
        pageSize: 10
      },

      infoDialog: false,
      jsontext: null,
      infotableName: '', // 打开的弹窗表名
      datainfo: {}, // 打开的弹窗对象
    }
  },

  created() {
    this.getList()
  },

  methods: {
    // 获取数据
    getList() {
        this.columnNamearr= [];
      this.listLoading = true
      ajax_middleTableData(this.tableName, this.listQuery.pageNo, this.listQuery.pageSize).then(response => {
        if (response.code == 1) {
          this.listLoading = false
          this.tableData = response.data.result


          // for (var key in this.tableData) {
          //   this.tableData[key].caozuo=[true,false]
          // }
          for (var key in this.tableData[0]) {
            this.columnNamearr.push({
              label: key, show: true,prop:key
            })
          }
          console.log(this.tableData)

          this.total = response.data.totalCount
        } else {
          this.listLoading = false
        }
      })
    },
    indexOfstr(val) {
      val = val + ""
      if (val.indexOf("_click_") != -1) {
        return true
      } else {
        return false
      }
    },

    tablelistdis(obj) {
      if (obj.show == true) {
        obj.show = false;
      } else {
        obj.show = true;
      }
    },

    selectable(e,v){
      return e.caozuo[1]
    },

    // 全选
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection)
    },

    // 打开 并复制
    openCopy(row) {
      this.$refs['copyDialog'].init(row)
    },
    // 打开弹窗
    openPopup(row, name) {
      this.infotableName = name.replace("_click_", "")
      this.datainfo = row;
      this.$refs['infotable'].init()
    }

  }
}
</script>

<style lang="scss" scoped>
.link {
  color: #646cf5;
  cursor: pointer;
}
.shaixuanlielist {
  float: left;
  width: 33%;
  cursor: pointer;
  line-height: 30px;
}
.shaixuantextcolor {
  color: #46a6ff;
}
</style>